import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
const DesktopSkeletonListItem = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex grow items-center gap-16");
    t1 = <Skeleton className="size-104 rounded-xlarge" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className={t0}>{t1}<div className="flex grow flex-col gap-8"><Skeleton className="h-27 w-full rounded-xxsmall" /><Skeleton className="h-27 w-2/3 rounded-xxsmall" /><Skeleton className="h-27 w-1/2 rounded-xxsmall" /></div></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const DesktopSkeletonCover = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("z-10 flex size-full flex-col bg-[#767676] pb-[calc(20px+var(--safe-area-bottom,0px))] pt-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-34 flex items-center justify-between px-40 content-container"><Skeleton className="h-36 w-106 rounded-xxsmall" /><Skeleton className="h-44 w-[352px] rounded-xxsmall" /><Skeleton className="h-24 w-222 rounded-xxsmall" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-80 flex h-240 shrink-0 justify-center gap-12 overflow-hidden"><Skeleton className="h-full w-[670px] shrink-0 rounded-large" /><Skeleton className="h-full w-[670px] shrink-0 rounded-large" /><Skeleton className="h-full w-[670px] shrink-0 rounded-large" /></div>;
    t4 = <Skeleton className="mx-auto mb-16 h-36 w-230 shrink-0 rounded-xxsmall" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ul className="mb-160 flex gap-40 px-40 py-28 content-container"><DesktopSkeletonListItem /><DesktopSkeletonListItem /><DesktopSkeletonListItem /></ul>;
    t6 = <Skeleton className="mx-auto mb-16 h-34 w-204 shrink-0 rounded-xxsmall" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ul className="flex h-[340px] shrink-0 gap-20 px-40 content-container"><Skeleton className="h-full w-224 shrink-0 rounded-xlarge" /><Skeleton className="h-full w-224 shrink-0 rounded-xlarge" /><Skeleton className="h-full w-224 shrink-0 rounded-xlarge" /><Skeleton className="h-full w-224 shrink-0 rounded-xlarge" /><Skeleton className="h-full w-224 shrink-0 rounded-xlarge" /></ul>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t1) {
    t8 = <div className={t1}>{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[8] = t1;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};